var _linearGradient, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 28,
    viewBox: "0 0 24 28",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0.040039,
    x2: 23.042,
    y1: 13.7416,
    y2: 13.7416
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002f87"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.7569 26.2998c3.341-2.9404 9.2851-8.9478 9.2851-14.4606 0-3.05021-1.2117-5.97553-3.3686-8.13239-2.1568-2.15685-5.0821-3.368553-8.1324-3.368553-3.05023 0-5.97555 1.211703-8.1324 3.368553-2.15685 2.15686-3.3685609 5.08218-3.3685609 8.13239 0 5.5128 5.9421709 11.5202 9.2851209 14.4606.60977.5443 1.39854.8451 2.21584.8451.8174 0 1.6061-.3008 2.2159-.8451zm-6.04954-14.4606c0-1.0167.4039-1.99182 1.12285-2.71077s1.69409-1.12286 2.71079-1.12286c1.0168 0 1.9919.40391 2.7108 1.12286.719.71895 1.1229 1.69407 1.1229 2.71077 0 1.0168-.4039 1.9919-1.1229 2.7108-.7189.719-1.694 1.1229-2.7108 1.1229-1.0167 0-1.99184-.4039-2.71079-1.1229-.71895-.7189-1.12285-1.694-1.12285-2.7108z",
    fill: "url(#a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ba2e24f78f4e142f62dc5212449c79e2.svg";
export { ForwardRef as ReactComponent };